import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN,
  USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS,
  USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE,
  USUARIO_PERFIL_LISTAR_ATIVOS_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function listarAtivos(callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN,
    callback,
  };
}

export function dismissListarAtivosError() {
  return {
    type: USUARIO_PERFIL_LISTAR_ATIVOS_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN actions
export function* doListarAtivos(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioPerfilApi = new Services['UsuarioPerfilApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioPerfilApi.find({ where: { Ativo: true }, order: 'Nome ASC' });
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListarAtivos() {
  yield takeLatest(USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN, doListarAtivos);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN:
      return {
        ...state,
        registros: [],
        listarAtivosPending: true,
        listarAtivosError: null,
      };

    case USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS:
      return {
        ...state,
        registros: action.data,
        listarAtivosPending: false,
        listarAtivosError: null,
      };

    case USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE:
      return {
        ...state,
        listarAtivosPending: false,
        listarAtivosError: action.data.error,
      };

    case USUARIO_PERFIL_LISTAR_ATIVOS_DISMISS_ERROR:
      return {
        ...state,
        listarAtivosError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/listarAtivos.js